(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/image-helpers.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/image-helpers.js'); 
'use strict';

function registerHelpers(hbs, config) {
  function isAbsoluteUrl(url) {
    return url && url.indexOf('http') === 0;
  }
  function getImageUrl(url) {
    url = isAbsoluteUrl(url) ? url : config.options.cdn2 + url;
    return url;
  }
  function getImage(image) {
    var _image$url;
    return image !== null && image !== void 0 && image.legacy ? image === null || image === void 0 ? void 0 : image.url : (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace('-{width}', '');
  }
  hbs.registerHelper('originalImageSrcset', image => {
    var _getImage;
    const srcset = (_getImage = getImage(image)) === null || _getImage === void 0 ? void 0 : _getImage.replace('{extension}', 'original').replace('{width}', 'original');
    return new hbs.SafeString(srcset);
  });
  hbs.registerHelper('newImageSrcset', function (image) {
    let extension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const srcset = [];
    const cleanedExtension = typeof extension === 'string' && extension.replace(/\./g, '');
    const availableWidths = image.availableWidths || ['noAvailableWidths'];
    let imageUrl = getImage(image);
    if (!image.isPreview && typeof cleanedExtension === 'string') {
      imageUrl = image !== null && image !== void 0 && image.legacy ? "".concat(image.url.substr(0, image.url.lastIndexOf('.')), ".").concat(cleanedExtension) : imageUrl.replace('{extension}', cleanedExtension);
    }
    availableWidths.forEach(size => {
      var _image$aspectRatio, _imageUrl;
      const width = size === 'original' && image !== null && image !== void 0 && image.legacy ? image === null || image === void 0 ? void 0 : (_image$aspectRatio = image.aspectRatio) === null || _image$aspectRatio === void 0 ? void 0 : _image$aspectRatio.width : size;
      const useOriginal = width => !width || width === 'original' || width === 'noAvailableWidths' ? '' : "".concat(width, "w");
      const url = getImageUrl((_imageUrl = imageUrl) === null || _imageUrl === void 0 ? void 0 : _imageUrl.replace('{width}', width));
      srcset.push("".concat(url, " ").concat(useOriginal(width)));
    });
    return new hbs.SafeString(srcset.join(','));
  });
  hbs.registerHelper('imageQueries', (image, selector) => {
    if (image !== null && image !== void 0 && image.media && image !== null && image !== void 0 && image.aspectRatio && selector) {
      return "@media only screen and ".concat(image.media, "{.").concat(selector.split(' ')[0], "{padding-bottom:").concat(image.aspectRatio.height / image.aspectRatio.width * 100, "%; background-color: ").concat(image.dominantColor, "}}");
    }
  });
}
if (svs.isServer) {
  registerHelpers(require('hbs'), require('trinidad-core').core.config);
} else {
  registerHelpers(Handlebars, {
    options: svs.core.config.data.svsconfig
  });
}
 })(window);